import PunchClockOutlinedIcon from '@mui/icons-material/PunchClockOutlined';
import Location from "../../../hooks/Location"
import useLogRecordOpen from "../../../hooks/useLogRecordOpen"
import { useFirestoreGeneral, useFirestoreGeneralTwo, useFirestoreOrderBy } from '../../../firebase/useFirestore';
import firebase from "../../../firebase/compat";
import { db } from '../../../firebase/config';
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import { useContext, useState } from "react";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Tooltip from '../../common/Tooltip';
import { useHistory } from "react-router-dom";
import UserNameMeta from '../../user/UserNameMeta';
import uuid from 'react-uuid';
import { client } from '../../../hooks/Client';
import DeleteModal from '../../common/DeleteModal';
import buildOutputEventResult from '../../../helpers/personas/buildOutputEventResult';
import pickLowestPosition from '../../../helpers/personas/pickLowestPosition';
import softDeleteDocs from '../../../helpers/softDeleteDocs';
import softDeleteDoc from '../../../helpers/softDeleteDoc';
import { Auth } from '../../../StateManagment/Auth';

const PersonaPresenceReportDetails = () => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // State
    const [correctionReason, setCorrectionReason] = useState('')
    const [editingDateDocid, setEditingDateDocid] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false)
    const [reportToDelete, setReportToDelete] = useState('')

    // Hooks
    const reportId = Location()[4]
    const personaId = Location()[3]
    // Auditlog: dit scherm toont dossiergegevens, dus het telt als raadpleging.
    useLogRecordOpen('persona', personaId)
    const history = useHistory()
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    // Firestore
    const presenceReports = useFirestoreGeneral('PersonaPresenceReports', 'ID', reportId ? reportId : '');
    const eventResults = useFirestoreGeneralTwo('EventResults', 'PersonaID', personaId ? personaId : '', 'Type', 'outputs');
    const activities = useFirestoreOrderBy('Activities', 'Position', 'asc');
    const outputs = useFirestoreOrderBy('Outputs', 'Position', 'asc');

    // Update report type
    const updateReportType = (e) => {
      const value = e.target.value

      db.collection('PersonaPresenceReports')
        .doc(e.target.dataset.docid)
        .update({
          Type: value
        })

      setSaved(true)
    }

    // Update start and endtime
  const startTimeHandler = (e) => {
    const value = e.target.value

    db.collection('PersonaPresenceReports')
      .doc(e.target.dataset.docid)
      .update({
        CorrectedStart: value
      })

    setSaved(true)
  }

  const endTimeHandler = (e) => {
    const value = e.target.value

    db.collection('PersonaPresenceReports')
      .doc(e.target.dataset.docid)
      .update({
        CorrectedEnd: value
      })

    setSaved(true)
  }

  // Update absent reason
  const absentReasonHandler = (e) => {
    const value = e.target.value

    db.collection('PersonaPresenceReports')
      .doc(e.target.dataset.docid)
      .update({
        Reason: value
      })

    setSaved(true)
  }

  // Update correction reason
  const correctionReasonHandler = (e) => {
    const value = e.target.value

    db.collection('PersonaPresenceReports')
      .doc(e.target.dataset.docid)
      .update({
        Reason: value
      })

    setSaved(true)
  }

  // Format date to Dutch string
  const formatDateToDutchString = (date) => {
    const daysOfWeek = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
    const monthsOfYear = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    const dayName = daysOfWeek[date.getDay()];
    const day = date.getDate();
    const monthName = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();
    return `${dayName} ${day} ${monthName} ${year}`;
  };

  // Update report date
  const dateHandler = (e, docid) => {
    const value = e.target.value;
    if (!value) return;

    const newDate = new Date(value + 'T12:00:00');

    db.collection('PersonaPresenceReports')
      .doc(docid)
      .update({
        Date: formatDateToDutchString(newDate),
        Timestamp: firebase.firestore.Timestamp.fromDate(newDate),
      })

    setEditingDateDocid(null);
    setSaved(true);
  };

  // Parse Dutch date string to YYYY-MM-DD for the date input
  const dutchDateToInputValue = (dutchDate) => {
    const monthsOfYear = {
      januari: 0, februari: 1, maart: 2, april: 3, mei: 4, juni: 5,
      juli: 6, augustus: 7, september: 8, oktober: 9, november: 10, december: 11,
    };
    const parts = dutchDate ? dutchDate.split(' ') : [];
    if (parts.length < 4) return '';
    const day = parseInt(parts[1]);
    const month = monthsOfYear[parts[2]];
    const year = parseInt(parts[3]);
    if (isNaN(day) || month === undefined || isNaN(year)) return '';
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  };

  // Eerst bevestigen: één klik op het prullenbakje verwijderde het
  // aanwezigheidsrapport meteen en onherstelbaar.
  const askDeleteReport = (e) => {
    const docid = e.currentTarget.dataset.docid
    if (!docid) return
    setReportToDelete(docid)
    setDeleteModal(true)
  }

  // Naar de prullenbak, niet definitief weg (ADR-008).
  // AI-CONTEXT: See docs/pitfalls.md#ui-soft-delete-promises-a-trash-it-is-not-in
  const deleteReport = async () => {
    if (!reportToDelete) return
    await softDeleteDoc({
      collection: 'PersonaPresenceReports',
      docid: reportToDelete,
      authId: auth?.ID,
      title: 'Aanwezigheidsrapport',
    })
    setSaved(true)
  }

  // Legt één EventResults-document vast voor een output, met de deelnemer in
  // `Participants`. Tot 2026-08-25 schreef dit een tweede document met
  // `Type: 'participants'` erbij; die vorm is vervallen. De vorm zelf komt uit
  // buildOutputEventResult, zodat deze schrijver en de nachtklus
  // (functions/personas/updatePersonaEvents.js) niet uit elkaar lopen.
  const createOutputEventResult = async (outputID) => {
    // Resolve Output → ActivityID + CompagnyID
    const outputDoc = outputs && outputs.find(o => o.ID === outputID);
    const activityId = outputDoc?.ActivityID || '';
    const compId = outputDoc?.CompagnyID || client;

    if (!activityId) return;

    // Resolve ActivityID → EventForm → EventID. Zonder sorteervolgorde levert
    // Firestore bij meerdere formulieren een willekeurige; daarom hier
    // sorteren op Position en dan op ID.
    const eventFormSnap = await db.collection('EventForms').where('ActivityID', '==', activityId).get();
    if (eventFormSnap.empty) return;
    const eventFormId = pickLowestPosition(eventFormSnap.docs)?.ID || '';
    if (!eventFormId) return;

    const outputsFieldSnap = await db
      .collection('EventFields')
      .where('EventId', '==', eventFormId)
      .where('Type', '==', 'outputs')
      .get();

    const outputsFieldId = pickLowestPosition(outputsFieldSnap.docs)?.ID || '';

    // Position base per OutputID. Met CompagnyID: EventResults is alleen voor
    // het eigen team leesbaar, en zonder dat filter weigeren de regels de query.
    // AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch
    const posSnap = await db.collection('EventResults')
      .where('CompagnyID', '==', compId)
      .where('OutputID', '==', outputID)
      .get();
    const basePos = posSnap.size;

    await db.collection('EventResults').doc().set(
      buildOutputEventResult({
        id: uuid(),
        sessionId: uuid(),
        compagnyId: compId,
        outputID,
        activityId,
        eventFormId,
        fieldId: outputsFieldId,
        // Niet de `timestamp` uit firebase/config: die staat vast op het
        // moment dat de pagina werd geladen, dus een tab die al uren openstaat
        // stempelt alles op dat oude tijdstip.
        // AI-CONTEXT: See docs/pitfalls.md#state-stale-module-level-timestamp
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        value: 1,
        position: basePos + 1,
        participants: [personaId],
        personaId,
        user: 'Deccos',
      })
    );
  }

  // Een registratie (alle documenten met dezelfde SessionID) naar de
  // prullenbak, niet definitief weg (ADR-008). De documenten gaan als één
  // geheel: terugzetten brengt de hele registratie terug.
  // AI-CONTEXT: See docs/pitfalls.md#ui-soft-delete-promises-a-trash-it-is-not-in
  const deleteEventResultBySession = async (sessionId) => {
    if (!sessionId) return;
    const snap = await db.collection('EventResults')
      .where('CompagnyID', '==', client)
      .where('SessionID', '==', sessionId)
      .get();
    await softDeleteDocs({
      collection: 'EventResults',
      docids: snap.docs.map(doc => doc.id),
      authId: auth?.ID,
      title: 'Registratie',
    });
  }

  // Select handler — creates new pair (and deletes old if replacing)
  const outputResultHandler = async (e) => {
    const outputID = e.target.value;
    const sessionId = e.target.dataset.sessionid;

    if (!outputID) return;

    if (sessionId) {
      await deleteEventResultBySession(sessionId);
    }

    await createOutputEventResult(outputID);
    setSaved(true);
  }

  // Explicit delete button
  const deleteEventResult = async (e) => {
    const sessionId = e.currentTarget.dataset.sessionid;
    await deleteEventResultBySession(sessionId);
    setSaved(true);
  }

  // Display author
  const displayAuthor = (author) => {
    if (author === 'system') {
      return (
        <p>Deccos</p>
      )
    } else {
      return (
        <UserNameMeta userID={author} />
      )
    }
  }

  // Build the grouped output select options (shared between empty and populated rows)
  const outputSelectOptions = (
    <>
      <option value=''>-- Selecteer output --</option>
      {activities && activities.map(act => {
        const actOutputs = outputs ? outputs.filter(o => o.ActivityID === act.ID && !o.Deleted) : [];
        if (actOutputs.length === 0) return null;
        return (
          <optgroup key={act.ID} label={act.Activity}>
            {actOutputs.map(out => (
              <option key={out.ID} value={out.ID}>{out.Title} ({act.Activity})</option>
            ))}
          </optgroup>
        );
      })}
    </>
  );

  return (
    <div className="main">
      <div className="main-container">
        <div className="page-header">
          <PunchClockOutlinedIcon />
          <h1>Aanwezigheidsrapport</h1>
        </div>
        <div className='table-container dashboard-container'>
           {presenceReports && presenceReports.map((report) => (
            <div>
              <div id='persona-presence-report-detail-author-container'>
                <p>Aangemaakt op {report.Timestamp.toDate().toLocaleDateString("nl-NL", options)} door</p>
                {displayAuthor(report.Author)}
              </div>
                {editingDateDocid === report.docid ? (
                  <input
                    type="date"
                    defaultValue={dutchDateToInputValue(report.Date)}
                    onChange={(e) => dateHandler(e, report.docid)}
                    onBlur={() => setEditingDateDocid(null)}
                    autoFocus
                  />
                ) : (
                  <div className="presence-report-date-container">
                    <h2>{report.Date}</h2>
                    <EditOutlinedIcon
                      className="presence-report-date-edit-icon"
                      onClick={() => setEditingDateDocid(report.docid)}
                    />
                  </div>
                )}
                <div>
                    <select name="" id="" defaultValue={report.Type} data-docid={report.docid} onChange={updateReportType}>
                        <option value="correct">Aanwezig</option>
                        <option value="absent">Afwezig</option>
                        <option value="correction">Aanpassing</option>
                    </select>
                </div>

                <div style={{display: report.Type === 'correct' ? 'block' : 'none'}}>
                  <h3>Start en eindtijd</h3>
                  <div id='presence-report-detail-times-input-container'>
                    <input type="time" defaultValue={report.Start} data-docid={report.docid} onChange={startTimeHandler} />
                    <p>-</p>
                    <input type="time" defaultValue={report.End} data-docid={report.docid} onChange={endTimeHandler} />
                  </div>
                </div>

                <div style={{display: report.Type === 'correction' ? 'block' : 'none'}}>
                  <h3>Start en eindtijd</h3>
                  <div id='presence-report-detail-times-input-container'>
                    <input type="time" defaultValue={report.CorrectedStart ? report.CorrectedStart : report.Start} data-docid={report.docid} onChange={startTimeHandler} />
                    <p>-</p>
                    <input type="time" defaultValue={report.CorrectedEnd ? report.CorrectedEnd : report.End} data-docid={report.docid} onChange={endTimeHandler} />
                  </div>
                  <h3>Reden correctie</h3>
                  <input type="text" placeholder='Reden correctie' defaultValue={report.Reason} data-docid={report.docid} onChange={correctionReasonHandler} />
                </div>

                <div style={{display: report.Type === 'absent' ? 'block' : 'none'}}>
                    <h3>Afwezig</h3>
                    <h3>Reden correctie</h3>
                    <input type="text" placeholder='Reden correctie' defaultValue={report.Reason} data-docid={report.docid} onChange={absentReasonHandler} />
                </div>

                <div id='presence-report-detail-outputs-container'>
                  <h3>Outputs</h3>
                  {eventResults && eventResults.length > 0 ? eventResults.map(result => (
                    <div key={result.docid} className='presence-report-detail-output-row'>
                      <select
                        data-sessionid={result.SessionID}
                        value={result.OutputID || ''}
                        onChange={outputResultHandler}
                      >
                        {outputSelectOptions}
                      </select>
                      <Tooltip content="Verwijderen" top={'-40px'}>
                        <DeleteOutlineOutlinedIcon data-sessionid={result.SessionID} onClick={deleteEventResult} />
                      </Tooltip>
                    </div>
                  )) : (
                    <div className='presence-report-detail-output-row'>
                      <select value='' data-sessionid='' onChange={outputResultHandler}>
                        {outputSelectOptions}
                      </select>
                    </div>
                  )}
                </div>

                <div id='presence-report-detail-options-container'>
                  <Tooltip content="Verwijderen" top={'-40px'}>
                    <DeleteOutlineOutlinedIcon data-docid={report.docid} onClick={askDeleteReport}/>
                  </Tooltip>
                </div>

            </div>
            ))}
        </div>
        <DeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          deleteItem={deleteReport}
          deleteName={'dit aanwezigheidsrapport'}
          softDelete
        />
      </div>
    </div>
  )
}

export default PersonaPresenceReportDetails
